/**
 * Hardcoded sample data used by the onboarding showcases AND mirrored by
 * the `seed_sample_trip()` RPC. Never written to the DB from the client.
 */

export type SamplePhoto = {
  id: string;
  url: string;
  caption: string;
  capturedAt: string;
  lat: number;
  lng: number;
};

export type SamplePod = {
  id: string;
  placeName: string;
  timeLabel: string;
  photos: SamplePhoto[];
};

export type SampleRoutePoint = { lat: number; lng: number };

export type SampleTrip = {
  name: string;
  destination: string;
  days: number;
  route: SampleRoutePoint[];
  pods: SamplePod[];
};

const photo = (n: number): string =>
  `https://picsum.photos/seed/roava-sample-${n}/800/1000`;

export const SAMPLE_TRIP: SampleTrip = {
  name: "Sample trip — Ulaanbaatar to Kharkhorin",
  destination: "Mongolia",
  days: 2,
  route: [
    { lat: 47.9184, lng: 106.9177 },
    { lat: 47.63, lng: 105.8 },
    { lat: 47.45, lng: 104.5 },
    { lat: 47.2, lng: 103.2 },
    { lat: 47.1956, lng: 102.8453 },
  ],
  pods: [
    {
      id: "pod-1",
      placeName: "Ulaanbaatar — Sukhbaatar Square",
      timeLabel: "Day 1 · Morning",
      photos: [
        { id: "p1", url: photo(1), caption: "Square at sunrise", capturedAt: "08:14", lat: 47.9184, lng: 106.9177 },
        { id: "p2", url: photo(2), caption: "Statue close-up", capturedAt: "08:42", lat: 47.9201, lng: 106.918 },
      ],
    },
    {
      id: "pod-2",
      placeName: "Roadside steppe",
      timeLabel: "Day 1 · Afternoon",
      photos: [
        { id: "p3", url: photo(3), caption: "Open plain", capturedAt: "14:05", lat: 47.45, lng: 104.5 },
        { id: "p4", url: photo(4), caption: "Wild horses", capturedAt: "14:38", lat: 47.451, lng: 104.502 },
      ],
    },
    {
      id: "pod-3",
      placeName: "Kharkhorin — Erdene Zuu",
      timeLabel: "Day 2 · Late afternoon",
      photos: [
        { id: "p5", url: photo(5), caption: "Monastery wall", capturedAt: "16:22", lat: 47.1956, lng: 102.8453 },
        { id: "p6", url: photo(6), caption: "Prayer flags", capturedAt: "16:55", lat: 47.196, lng: 102.847 },
      ],
    },
  ],
};

export const ALL_SAMPLE_PHOTOS: SamplePhoto[] = SAMPLE_TRIP.pods.flatMap((p) => p.photos);
